export enum DietaryPreference {
  VEGETARIAN = 'Vegetarian',
  HALAL = 'Halal',
  NO_SPECIAL_REQUIREMENTS = 'No Special Requirements',
  N_A = 'Not Applicable', // For those not attending
}

// Event-specific constants
export const EVENT_YEAR_TEAM = '2025 TEAM';
export const EVENT_TITLE = 'HOLIDAY CELEBRATION';
export const INTRO_TEXT = `We warmly invite you to our annual Holiday
Celebration – an evening dedicated to saying
thank you to the team and getting together in
a festive atmosphere.`;

export const EVENT_MONTH = 'DECEMBER';
export const EVENT_DAY_TEXT = 'TUESDAY';
export const EVENT_DAY_NUMBER = '02';
export const EVENT_FULL_YEAR = '2025';
export const EVENT_TIME = 'AT 8 PM';
export const EVENT_LOCATION_NAME = 'THEATERHOTEL DE ORANJERIE';
export const EVENT_LOCATION_CITY = 'ROERMOND';

export const CLOSING_TEXT = 'We look forward to celebrating with you!';

// Dashboard password (for demonstration purposes, ideally from an env var or backend)
export const DASHBOARD_PASSWORD = 'ralph4Roermond!?';